import React from "react";

import styles from "./EmptyLayout.module.scss";

export const EmptyLayout: React.FC = ({ children }) => {
  return <div className={styles.appScreen}>{children}</div>;
};
